var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('img',{attrs:{"src":"https://cdncampaigns.cathaylife.com.tw/OAWeb/html/OA/C8/img/logo/Cathay-life-rgb-db.svg","alt":"國泰人壽"}})])
}]

export { render, staticRenderFns }